import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { SelectionId } from 'src_common/common/websocket2/id/WebsocketId';
import { OutrightFill } from 'src/domains/sportsbook/webview/components/raceBoxSelection/RaceBoxSelection.style';
import emptyHrSilk from 'src/domains/layouts/shared/assets/silk/empty-hr-silk.svg';
import {
    LazyImageWrapper,
    LazyImageWrapperNextRaces,
    WidgetSilkBox,
} from 'src/domains/sportsbook/webview/components/nextRaces/raceBoxSelection/WidgetSilk.style';

interface WidgetSilkPropsType {
    selectionId: SelectionId;
}

export const WidgetSilk = observer('WidgetSilk', (props: WidgetSilkPropsType) => {
    const { selectionId } = props;
    const selection = selectionId.getModel();
    const market = selection?.marketId2.getModel() ?? null;

    if (selection === null || market === null) {
        return null;
    }

    const silkUrl = selection.metaDataSilkUrl;

    if (market.isOutright !== true) {
        return <OutrightFill />;
    }

    return (
        <WidgetSilkBox>
            <LazyImageWrapperNextRaces>
                <LazyImageWrapper
                    alt={selection.isMetaData ? selection.metaDataSilk : null}
                    placeholder={emptyHrSilk}
                    src={silkUrl}
                />
            </LazyImageWrapperNextRaces>
        </WidgetSilkBox>
    );
});
